import PageHeader from 'components/pageHeader/PageHeader';
import FormWithProvider from 'components/forms/form/Form';
import { Trans } from 'react-i18next';
import usePropertySettingsInitData from '../usePropertySettingsInitData';
import PropertyEditPermissionInfo from '../common/PropertyEditPermissionInfo';
import PermissionsAwareFieldset from '../common/PermissionsAwareFieldset';
import { UnitListSchemaType, schema } from './PropertySettingsUnitsTab.schema';
import UnitList from './list/UnitList';
import useUnitSubmit from './useUnitSubmit';
import ButtonSubmitUnits from './submit/ButtonSubmitUnits';

const PropertySettingsUnitsTab = () => {
  const { property } = usePropertySettingsInitData();
  const { handleSaveUnits } = useUnitSubmit();

  const getDefaultValues = (): UnitListSchemaType => {
    const units: UnitListSchemaType['units'] = [];

    property?.units?.forEach((unit) => {
      units.push({
        ...unit,
        isActive: unit.isActive!,
        isTemporary: false,
      });
    });

    return {
      extraUnits: 1,
      units,
    };
  };

  const handleSubmit = (values: UnitListSchemaType) => {
    handleSaveUnits(values.units);
  };

  return (
    <FormWithProvider
      onSubmit={handleSubmit}
      schema={schema()}
      defaultValues={getDefaultValues()}
      dirtyChecker
      dirtyCheckerOptions={{
        skipFields: ['extraUnits'],
      }}
      key={property?.uid}
      noValidate
    >
      <PropertyEditPermissionInfo />

      <PageHeader
        className="tab-title"
        title={
          <Trans
            i18nKey="pageProperty.units.tabTitle"
            values={{ propertyName: property?.name }}
            components={{ 1: <span className="green" /> }}
          />
        }
        noDivider
      />

      <PermissionsAwareFieldset data-testid="units-form-fields">
        <UnitList />

        <ButtonSubmitUnits />
      </PermissionsAwareFieldset>
    </FormWithProvider>
  );
};

export default PropertySettingsUnitsTab;
